import { ComponentsType } from "types/CommonsTypes"
import { lazy } from "react"

const ScannerlTransition = lazy(() => import("components/Core/ProductTransition/ScannerlTransition"))
const TagConsolidation = lazy(() => import("webapp-clients/PRVL/Components/TagConsolidation"))
const TagCustomOrder = lazy(() => import("webapp-clients/PRVL/Components/TagCustomOrder"))
const CustomFilters = lazy(() => import("webapp-clients/PRVL/Components/CustomFilters"))
const TicketOrder = lazy(() => import("webapp-clients/PRVL/Components/TicketOrder"))

export const privilege: ComponentsType = {
  ProductTransition: ScannerlTransition,
  TagConsolidation,
  TagCustomOrder,
  CustomFilters,
  TicketOrder
}
